import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Typography,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { REACT_APP_BACKEND_URL } from "../../Utils/Language/urlBase";
import useAuthHeader from "react-auth-kit/hooks/useAuthHeader";

const BuyInvoices = () => {
    const [invoices, setInvoices] = useState([]);
    const authHeader = useAuthHeader();
    const navigate = useNavigate();

    // Fetch Buy Invoices
    useEffect(() => {
        const fetchBuyInvoices = async () => {
            const resp = await fetch(
                `${REACT_APP_BACKEND_URL}/invoices/buyInvoices`,
                {
                    method: "GET",
                    headers: {
                        Authorization: authHeader,
                        "Content-Type": "application/json",
                    },
                }
            );
            const result = await resp.json();
            setInvoices(result.buyInvoices); // Set the fetched invoices
        };
        fetchBuyInvoices();
    }, []);

    // Handles navigation when the eye icon is clicked
    const handleViewClick = (id) => {
        navigate(`/BuyInvoices/${id}`);
    };

    return (
        <Box sx={{ p: 3 }}>
            {/* Header */}
            <Typography
                variant="h4"
                component="h1"
                gutterBottom
                textAlign="center"
            >
                Buy Invoices
            </Typography>

            {/* Table */}
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Created At</TableCell>
                            <TableCell>Total Price</TableCell>
                            <TableCell>Employee</TableCell>
                            <TableCell>Other Party</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {invoices.map((invoice) => (
                            <TableRow key={invoice.id}>
                                {/* Invoice ID */}
                                <TableCell>{invoice.id}</TableCell>

                                {/* Created At */}
                                <TableCell>
                                    {new Date(
                                        invoice.createdAt
                                    ).toLocaleString()}
                                </TableCell>

                                {/* Total Price */}
                                <TableCell>${invoice.totalPrice}</TableCell>

                                {/* Employee Info */}
                                <TableCell>
                                    {invoice.employee.name} (
                                    {invoice.employee.username})
                                </TableCell>

                                {/* Other Party Info */}
                                <TableCell>
                                    {invoice.otherParty.name} (
                                    {invoice.otherParty.phone})
                                </TableCell>

                                {/* Actions */}
                                <TableCell>
                                    <IconButton
                                        onClick={() =>
                                            handleViewClick(invoice.id)
                                        }
                                        color="primary"
                                    >
                                        <VisibilityIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default BuyInvoices;
